import FrontHeader from '../components/FrontHeader'
import FrontFooter from '../components/FrontFooter'

function About() {
  return (
    <div>
      <div style={{backgroundColor: 'rgb(5, 8, 11)', position: 'relative'}}>
        <div class="position-absolute top-0 left-0 w-100 h-100 bg-black opacity-50" style={{zIndex: '10'}}></div>
        <FrontHeader/>
        <div className="container position-relative" style={{zIndex: '12', paddingBottom: '8rem', paddingTop: '8rem'}}>
            <div style={{maxWidth: '56rem'}}>
                <p className="text-prime mb-3 fw-bold" style={{fontSize: '14px'}}>About us</p>
                <h1 className="text-white fw-bold mb-5" style={{lineHeight: '1.1'}}>We bring honesty and transparency to financial services technology</h1>
                <p style={{fontSize: '18px'}}>Seamlessly merging complexity with ease, Ixprotrade offers top-notch security, 24/7 support, and an intuitive platform for your tenacious trading and investment needs.</p>
                <p style={{fontSize: '18px'}}>Through our Ixprotrade platform, you can take advantage of high liquidity, low spreads, mobile trading, technical analysis and even more.</p>
                <p style={{fontSize: '18px'}}>We maintain high standards to keep trading environments secure, and offer the best tailor made trading conditions for every client. We help Forex traders to develop the knowledge and skills they need to trade efficiently and responsibly.</p>
                <p style={{fontSize: '18px'}}>We aspire to do this by building fine products that can help boost business activity, remove inefficiencies and provide better performance and growth.</p>
            </div>
        </div>
      </div>
      <section className="bg-white" style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
          <h1 className="mb-4 text-black">Why we’re better</h1>
          <p className="mb-5 text-black" style={{maxWidth: '40rem'}}>Our team comprises of industry experts who are driven to consistently improve your trading experience.</p>
          <div className="row">
            <div className="col-lg-4 col-12">
              <div>
                <h6 className="fw-bold mb-2 text-black">Ixprotrade Account</h6>
                <p className="text-dark mb-0">At our platform, we offer a single, unified trading account type, designed to simplify and streamline your trading experience with us.</p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div>
                <h6 className="fw-bold mb-2 text-black">Licensed and Regulated</h6>
                <p className="text-dark mb-0">We hold ourselves to the highest levels of integrity and professionalism, diligently respecting and abiding by the industry standards and regulations that govern our field.</p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div>
                <h6 className="fw-bold mb-2 text-black">Instant account opening and funding</h6>
                <p className="text-dark mb-0">Our registration process is designed with your convenience in mind, featuring a simple and straightforward registration form coupled with a fast an easy verification process.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FrontFooter/>
    </div>
  )
}

export default About